module.exports = __webpack_public_path__ + "static/media/sliders-h.c199dcd7.svg";